var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video_box_s"},[_c('div',{staticClass:"video_box"},[_c('div',{staticClass:"video_con"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src,"frameborder":"0","id":"iframe"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }